// --
// Dependencies
import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme/styles/index.scss';


// --
// Components
import App from './components/App';


const root = ReactDOM.createRoot( document.getElementById( 'root' ));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);